module.exports = __webpack_public_path__ + "img/Date.253cc885.jpeg";